var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgCustomerCareFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1219_97889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 3.33333C8.23173 3.33333 6.53604 4.03571 5.28579 5.28595C4.03555 6.5362 3.33317 8.23189 3.33317 10H5.83317C6.2752 10 6.69912 10.1756 7.01168 10.4882C7.32424 10.8007 7.49984 11.2246 7.49984 11.6667V15.8333C7.49984 16.2754 7.32424 16.6993 7.01168 17.0118C6.69912 17.3244 6.2752 17.5 5.83317 17.5H3.33317C2.89114 17.5 2.46722 17.3244 2.15466 17.0118C1.8421 16.6993 1.6665 16.2754 1.6665 15.8333V10C1.6665 5.3975 5.39734 1.66667 9.99984 1.66667C14.6023 1.66667 18.3332 5.3975 18.3332 10V15.8333C18.3332 16.2754 18.1576 16.6993 17.845 17.0118C17.5325 17.3244 17.1085 17.5 16.6665 17.5H14.1665C13.7245 17.5 13.3006 17.3244 12.988 17.0118C12.6754 16.6993 12.4998 16.2754 12.4998 15.8333V11.6667C12.4998 11.2246 12.6754 10.8007 12.988 10.4882C13.3006 10.1756 13.7245 10 14.1665 10H16.6665C16.6665 8.23189 15.9641 6.5362 14.7139 5.28595C13.4636 4.03571 11.7679 3.33333 9.99984 3.33333ZM3.33317 11.6667V15.8333H5.83317V11.6667H3.33317ZM14.1665 11.6667V15.8333H16.6665V11.6667H14.1665Z",
    fill: "#216AE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1219_97889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCustomerCareFocus);
export default __webpack_public_path__ + "static/media/svg_customer_care_focus.34938b15899c3a045821e887def6911a.svg";
export { ForwardRef as ReactComponent };